import React from "react";
import "../styles/AppFooter.css";

function AppFooter() {
  return (
    <footer className="app-footer">
      <p>
        <a
          href="https://blog.patientmanager.com.ar/terminos-y-condiciones/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Términos y condiciones
        </a>{" "}
        |{" "}
        <a
          href="https://blog.patientmanager.com.ar/politica-de-privacidad/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Política de privacidad
        </a>
      </p>
    </footer>
  );
}

export default AppFooter;
